import React from "react";
export const AppConstants = {
  countryRules:  [
    {
      name: "Laos",
      code: "LA",
      phone_code: "+856",
      phone_regex: "^\\+856\\d{10}$"
    },
    {
      name: "Afghanistan",
      code: "AF",
      phone_code: "+93",
      phone_regex: "^\\+93\\d{9}$"
    },
    {
      name: "Albania",
      code: "AL",
      phone_code: "+355",
      phone_regex: "^\\+355\\d{9}$"
    },
    {
      name: "Algeria",
      code: "DZ",
      phone_code: "+213",
      phone_regex: "^\\+213\\d{9}$"
    },
    {
      name: "Andorra",
      code: "AD",
      phone_code: "+376",
      phone_regex: "^\\+376\\d{6}$"
    },
    {
      name: "Angola",
      code: "AO",
      phone_code: "+244",
      phone_regex: "^\\+244\\d{9}$"
    },
    {
      name: "Antigua and Barbuda",
      code: "AG",
      phone_code: "+1-268",
      phone_regex: "^\\+1\\-268\\d{7}$"
    },
    {
      name: "Argentina",
      code: "AR",
      phone_code: "+54",
      phone_regex: "^\\+54\\d{8,10}$"
    },
    {
      name: "Armenia",
      code: "AM",
      phone_code: "+374",
      phone_regex: "^\\+374\\d{8}$"
    },
    {
      name: "Australia",
      code: "AU",
      phone_code: "+61",
      phone_regex: "^\\+61\\d{9}$"
    },
    {
      name: "Austria",
      code: "AT",
      phone_code: "+43",
      phone_regex: "^\\+43\\d{6,13}$"
    },
    {
      name: "Azerbaijan",
      code: "AZ",
      phone_code: "+994",
      phone_regex: "^\\+994\\d{9}$"
    },
    {
      name: "Bahamas",
      code: "BS",
      phone_code: "+1-242",
      phone_regex: "^\\+1\\-242\\d{7}$"
    },
    {
      name: "Bahrain",
      code: "BH",
      phone_code: "+973",
      phone_regex: "^\\+973\\d{8}$"
    },
    {
      name: "Bangladesh",
      code: "BD",
      phone_code: "+880",
      phone_regex: "^\\+880\\d{10}$"
    },
    {
      name: "Barbados",
      code: "BB",
      phone_code: "+1-246",
      phone_regex: "^\\+1\\-246\\d{7}$"
    },
    {
      name: "Belarus",
      code: "BY",
      phone_code: "+375",
      phone_regex: "^\\+375\\d{9}$"
    },
    {
      name: "Belgium",
      code: "BE",
      phone_code: "+32",
      phone_regex: "^\\+32\\d{8,9}$"
    },
    {
      name: "Belize",
      code: "BZ",
      phone_code: "+501",
      phone_regex: "^\\+501\\d{7}$"
    },
    {
      name: "Benin",
      code: "BJ",
      phone_code: "+229",
      phone_regex: "^\\+229\\d{8}$"
    },
    {
      name: "Bhutan",
      code: "BT",
      phone_code: "+975",
      phone_regex: "^\\+975\\d{8}$"
    },
    {
      name: "Bolivia",
      code: "BO",
      phone_code: "+591",
      phone_regex: "^\\+591\\d{7,8}$"
    },
    {
      name: "Bosnia and Herzegovina",
      code: "BA",
      phone_code: "+387",
      phone_regex: "^\\+387\\d{8}$"
    },
    {
      name: "Botswana",
      code: "BW",
      phone_code: "+267",
      phone_regex: "^\\+267\\d{7,8}$"
    },
    {
      name: "Brazil",
      code: "BR",
      phone_code: "+55",
      phone_regex: "^\\+55\\d{10,11}$"
    },
    {
      name: "Brunei",
      code: "BN",
      phone_code: "+673",
      phone_regex: "^\\+673\\d{7}$"
    },
    {
      name: "Bulgaria",
      code: "BG",
      phone_code: "+359",
      phone_regex: "^\\+359\\d{8,9}$"
    },
    {
      name: "Burkina Faso",
      code: "BF",
      phone_code: "+226",
      phone_regex: "^\\+226\\d{8}$"
    },
    {
      name: "Burundi",
      code: "BI",
      phone_code: "+257",
      phone_regex: "^\\+257\\d{8}$"
    },
    {
      name: "Cambodia",
      code: "KH",
      phone_code: "+855",
      phone_regex: "^\\+855\\d{8,9}$"
    },
    {
      name: "Cameroon",
      code: "CM",
      phone_code: "+237",
      phone_regex: "^\\+237\\d{8}$"
    },
    {
      name: "Canada",
      code: "CA",
      phone_code: "+1",
      phone_regex: "^\\+1\\d{10}$"
    },
    {
      name: "Cape Verde",
      code: "CV",
      phone_code: "+238",
      phone_regex: "^\\+238\\d{7}$"
    },
    {
      name: "Central African Republic",
      code: "CF",
      phone_code: "+236",
      phone_regex: "^\\+236\\d{8}$"
    },
    {
      name: "Chad",
      code: "TD",
      phone_code: "+235",
      phone_regex: "^\\+235\\d{8}$"
    },
    {
      name: "Chile",
      code: "CL",
      phone_code: "+56",
      phone_regex: "^\\+56\\d{9}$"
    },
    {
      name: "China",
      code: "CN",
      phone_code: "+86",
      phone_regex: "^\\+86\\d{11,12}$"
    },
    {
      name: "Colombia",
      code: "CO",
      phone_code: "+57",
      phone_regex: "^\\+57\\d{10}$"
    },
    {
      name: "Comoros",
      code: "KM",
      phone_code: "+269",
      phone_regex: "^\\+269\\d{7}$"
    },
    {
      name: "Congo (Democratic Republic of the)",
      code: "CD",
      phone_code: "+243",
      phone_regex: "^\\+243\\d{9}$"
    },
    {
      name: "Congo (Republic of the)",
      code: "CG",
      phone_code: "+242",
      phone_regex: "^\\+242\\d{9}$"
    },
    {
      name: "Costa Rica",
      code: "CR",
      phone_code: "+506",
      phone_regex: "^\\+506\\d{8}$"
    },
    {
      name: "Croatia",
      code: "HR",
      phone_code: "+385",
      phone_regex: "^\\+385\\d{8,9}$"
    },
    {
      name: "Cuba",
      code: "CU",
      phone_code: "+53",
      phone_regex: "^\\+53\\d{8}$"
    },
    {
      name: "Cyprus",
      code: "CY",
      phone_code: "+357",
      phone_regex: "^\\+357\\d{8}$"
    },
    {
      name: "Czechia",
      code: "CZ",
      phone_code: "+420",
      phone_regex: "^\\+420\\d{9}$"
    },
    {
      name: "Denmark",
      code: "DK",
      phone_code: "+45",
      phone_regex: "^\\+45\\d{8}$"
    },
    {
      name: "Djibouti",
      code: "DJ",
      phone_code: "+253",
      phone_regex: "^\\+253\\d{8}$"
    },
    {
      name: "Dominica",
      code: "DM",
      phone_code: "+1-767",
      phone_regex: "^\\+1\\-767\\d{7}$"
    },
    {
      name: "Dominican Republic",
      code: "DO",
      phone_code: "+1-809, +1-829, +1-849",
      phone_regex: "^\\+1\\-(809|829|849)\\d{7}$"
    },
    {
      name: "Ecuador",
      code: "EC",
      phone_code: "+593",
      phone_regex: "^\\+593\\d{8,9}$"
    },
    {
      name: "Egypt",
      code: "EG",
      phone_code: "+20",
      phone_regex: "^\\+20\\d{10}$"
    },
    {
      name: "El Salvador",
      code: "SV",
      phone_code: "+503",
      phone_regex: "^\\+503\\d{8}$"
    },
    {
      name: "Equatorial Guinea",
      code: "GQ",
      phone_code: "+240",
      phone_regex: "^\\+240\\d{7}$"
    },
    {
      name: "Eritrea",
      code: "ER",
      phone_code: "+291",
      phone_regex: "^\\+291\\d{7}$"
    },
    {
      name: "Estonia",
      code: "EE",
      phone_code: "+372",
      phone_regex: "^\\+372\\d{7,8}$"
    },
    {
      name: "Eswatini",
      code: "SZ",
      phone_code: "+268",
      phone_regex: "^\\+268\\d{8}$"
    },
    {
      name: "Ethiopia",
      code: "ET",
      phone_code: "+251",
      phone_regex: "^\\+251\\d{9}$"
    },
    {
      name: "Fiji",
      code: "FJ",
      phone_code: "+679",
      phone_regex: "^\\+679\\d{7}$"
    },
    {
      name: "Finland",
      code: "FI",
      phone_code: "+358",
      phone_regex: "^\\+358\\d{9}$"
    },
    {
      name: "France",
      code: "FR",
      phone_code: "+33",
      phone_regex: "^\\+33\\d{9}$"
    },
    {
      name: "Gabon",
      code: "GA",
      phone_code: "+241",
      phone_regex: "^\\+241\\d{7}$"
    },
    {
      name: "Gambia",
      code: "GM",
      phone_code: "+220",
      phone_regex: "^\\+220\\d{7}$"
    },
    {
      name: "Georgia",
      code: "GE",
      phone_code: "+995",
      phone_regex: "^\\+995\\d{9}$"
    },
    {
      name: "Germany",
      code: "DE",
      phone_code: "+49",
      phone_regex: "^\\+49\\d{7,15}$"
    },
    {
      name: "Ghana",
      code: "GH",
      phone_code: "+233",
      phone_regex: "^\\+233\\d{9}$"
    },
    {
      name: "Greece",
      code: "GR",
      phone_code: "+30",
      phone_regex: "^\\+30\\d{10}$"
    },
    {
      name: "Grenada",
      code: "GD",
      phone_code: "+1-473",
      phone_regex: "^\\+1\\-473\\d{7}$"
    },
    {
      name: "Guatemala",
      code: "GT",
      phone_code: "+502",
      phone_regex: "^\\+502\\d{8}$"
    },
    {
      name: "Guinea",
      code: "GN",
      phone_code: "+224",
      phone_regex: "^\\+224\\d{8}$"
    },
    {
      name: "Guinea-Bissau",
      code: "GW",
      phone_code: "+245",
      phone_regex: "^\\+245\\d{7}$"
    },
    {
      name: "Guyana",
      code: "GY",
      phone_code: "+592",
      phone_regex: "^\\+592\\d{7}$"
    },
    {
      name: "Haiti",
      code: "HT",
      phone_code: "+509",
      phone_regex: "^\\+509\\d{8}$"
    },
    {
      name: "Honduras",
      code: "HN",
      phone_code: "+504",
      phone_regex: "^\\+504\\d{8}$"
    },
    {
      name: "Hungary",
      code: "HU",
      phone_code: "+36",
      phone_regex: "^\\+36\\d{9}$"
    },
    {
      name: "Iceland",
      code: "IS",
      phone_code: "+354",
      phone_regex: "^\\+354\\d{7}$"
    },
    {
      name: "India",
      code: "IN",
      phone_code: "+91",
      phone_regex: "^\\+91\\d{10}$"
    },
    {
      name: "Indonesia",
      code: "ID",
      phone_code: "+62",
      phone_regex: "^\\+62\\d{9,12}$"
    },
    {
      name: "Iran",
      code: "IR",
      phone_code: "+98",
      phone_regex: "^\\+98\\d{10}$"
    },
    {
      name: "Iraq",
      code: "IQ",
      phone_code: "+964",
      phone_regex: "^\\+964\\d{10}$"
    },
    {
      name: "Ireland",
      code: "IE",
      phone_code: "+353",
      phone_regex: "^\\+353\\d{9}$"
    },
    {
      name: "Israel",
      code: "IL",
      phone_code: "+972",
      phone_regex: "^\\+972\\d{9}$"
    },
    {
      name: "Italy",
      code: "IT",
      phone_code: "+39",
      phone_regex: "^\\+39\\d{9,10}$"
    },
    {
      name: "Jamaica",
      code: "JM",
      phone_code: "+1-876",
      phone_regex: "^\\+1\\-876\\d{7}$"
    },
    {
      name: "Japan",
      code: "JP",
      phone_code: "+81",
      phone_regex: "^\\+81\\d{10}$"
    },
    {
      name: "Jordan",
      code: "JO",
      phone_code: "+962",
      phone_regex: "^\\+962\\d{9}$"
    },
    {
      name: "Kazakhstan",
      code: "KZ",
      phone_code: "+7",
      phone_regex: "^\\+7\\d{10}$"
    },
    {
      name: "Kenya",
      code: "KE",
      phone_code: "+254",
      phone_regex: "^\\+254\\d{9}$"
    },
    {
      name: "Kiribati",
      code: "KI",
      phone_code: "+686",
      phone_regex: "^\\+686\\d{5}$"
    },
    {
      name: "Korea, North",
      code: "KP",
      phone_code: "+850",
      phone_regex: "^\\+850\\d{9}$"
    },
    {
      name: "Korea, South",
      code: "KR",
      phone_code: "+82",
      phone_regex: "^\\+82\\d{10,11}$"
    },
    {
      name: "Kuwait",
      code: "KW",
      phone_code: "+965",
      phone_regex: "^\\+965\\d{8}$"
    },
    {
      name: "Kyrgyzstan",
      code: "KG",
      phone_code: "+996",
      phone_regex: "^\\+996\\d{9}$"
    },
    {
      name: "Latvia",
      code: "LV",
      phone_code: "+371",
      phone_regex: "^\\+371\\d{8}$"
    },
    {
      name: "Lebanon",
      code: "LB",
      phone_code: "+961",
      phone_regex: "^\\+961\\d{7,8}$"
    },
    {
      name: "Lesotho",
      code: "LS",
      phone_code: "+266",
      phone_regex: "^\\+266\\d{8}$"
    },
    {
      name: "Liberia",
      code: "LR",
      phone_code: "+231",
      phone_regex: "^\\+231\\d{8}$"
    },
    {
      name: "Libya",
      code: "LY",
      phone_code: "+218",
      phone_regex: "^\\+218\\d{9}$"
    },
    {
      name: "Liechtenstein",
      code: "LI",
      phone_code: "+423",
      phone_regex: "^\\+423\\d{7}$"
    },
    {
      name: "Lithuania",
      code: "LT",
      phone_code: "+370",
      phone_regex: "^\\+370\\d{8}$"
    },
    {
      name: "Luxembourg",
      code: "LU",
      phone_code: "+352",
      phone_regex: "^\\+352\\d{6,9}$"
    },
    {
      name: "Madagascar",
      code: "MG",
      phone_code: "+261",
      phone_regex: "^\\+261\\d{9}$"
    },
    {
      name: "Malawi",
      code: "MW",
      phone_code: "+265",
      phone_regex: "^\\+265\\d{9}$"
    },
    {
      name: "Malaysia",
      code: "MY",
      phone_code: "+60",
      phone_regex: "^\\+60\\d{9,10}$"
    },
    {
      name: "Maldives",
      code: "MV",
      phone_code: "+960",
      phone_regex: "^\\+960\\d{7}$"
    },
    {
      name: "Mali",
      code: "ML",
      phone_code: "+223",
      phone_regex: "^\\+223\\d{8}$"
    },
    {
      name: "Malta",
      code: "MT",
      phone_code: "+356",
      phone_regex: "^\\+356\\d{8}$"
    },
    {
      name: "Marshall Islands",
      code: "MH",
      phone_code: "+692",
      phone_regex: "^\\+692\\d{7}$"
    },
    {
      name: "Mauritania",
      code: "MR",
      phone_code: "+222",
      phone_regex: "^\\+222\\d{8}$"
    },
    {
      name: "Mauritius",
      code: "MU",
      phone_code: "+230",
      phone_regex: "^\\+230\\d{8}$"
    },
    {
      name: "Mexico",
      code: "MX",
      phone_code: "+52",
      phone_regex: "^\\+52\\d{10}$"
    },
    {
      name: "Micronesia",
      code: "FM",
      phone_code: "+691",
      phone_regex: "^\\+691\\d{7}$"
    },
    {
      name: "Moldova",
      code: "MD",
      phone_code: "+373",
      phone_regex: "^\\+373\\d{8}$"
    },
    {
      name: "Monaco",
      code: "MC",
      phone_code: "+377",
      phone_regex: "^\\+377\\d{8,9}$"
    },
    {
      name: "Mongolia",
      code: "MN",
      phone_code: "+976",
      phone_regex: "^\\+976\\d{8}$"
    },
    {
      name: "Montenegro",
      code: "ME",
      phone_code: "+382",
      phone_regex: "^\\+382\\d{8}$"
    },
    {
      name: "Morocco",
      code: "MA",
      phone_code: "+212",
      phone_regex: "^\\+212\\d{9}$"
    },
    {
      name: "Mozambique",
      code: "MZ",
      phone_code: "+258",
      phone_regex: "^\\+258\\d{9}$"
    },
    {
      name: "Myanmar",
      code: "MM",
      phone_code: "+95",
      phone_regex: "^\\+95\\d{9}$"
    },
    {
      name: "Namibia",
      code: "NA",
      phone_code: "+264",
      phone_regex: "^\\+264\\d{9}$"
    },
    {
      name: "Nauru",
      code: "NR",
      phone_code: "+674",
      phone_regex: "^\\+674\\d{7}$"
    },
    {
      name: "Nepal",
      code: "NP",
      phone_code: "+977",
      phone_regex: "^\\+977\\d{10}$"
    },
    {
      name: "Netherlands",
      code: "NL",
      phone_code: "+31",
      phone_regex: "^\\+31\\d{9}$"
    },
    {
      name: "New Zealand",
      code: "NZ",
      phone_code: "+64",
      phone_regex: "^\\+64\\d{8,9}$"
    },
    {
      name: "Nicaragua",
      code: "NI",
      phone_code: "+505",
      phone_regex: "^\\+505\\d{8}$"
    },
    {
      name: "Niger",
      code: "NE",
      phone_code: "+227",
      phone_regex: "^\\+227\\d{8}$"
    },
    {
      name: "Nigeria",
      code: "NG",
      phone_code: "+234",
      phone_regex: "^\\+234\\d{10}$"
    },
    {
      name: "North Macedonia",
      code: "MK",
      phone_code: "+389",
      phone_regex: "^\\+389\\d{8}$"
    },
    {
      name: "Norway",
      code: "NO",
      phone_code: "+47",
      phone_regex: "^\\+47\\d{8}$"
    },
    {
      name: "Oman",
      code: "OM",
      phone_code: "+968",
      phone_regex: "^\\+968\\d{8}$"
    },
    {
      name: "Pakistan",
      code: "PK",
      phone_code: "+92",
      phone_regex: "^\\+92\\d{10}$"
    },
    {
      name: "Palau",
      code: "PW",
      phone_code: "+680",
      phone_regex: "^\\+680\\d{7}$"
    },
    {
      name: "Panama",
      code: "PA",
      phone_code: "+507",
      phone_regex: "^\\+507\\d{8}$"
    },
    {
      name: "Papua New Guinea",
      code: "PG",
      phone_code: "+675",
      phone_regex: "^\\+675\\d{8}$"
    },
    {
      name: "Paraguay",
      code: "PY",
      phone_code: "+595",
      phone_regex: "^\\+595\\d{9}$"
    },
    {
      name: "Peru",
      code: "PE",
      phone_code: "+51",
      phone_regex: "^\\+51\\d{9}$"
    },
    {
      name: "Philippines",
      code: "PH",
      phone_code: "+63",
      phone_regex: "^\\+63\\d{10}$"
    },
    {
      name: "Poland",
      code: "PL",
      phone_code: "+48",
      phone_regex: "^\\+48\\d{9}$"
    },
    {
      name: "Portugal",
      code: "PT",
      phone_code: "+351",
      phone_regex: "^\\+351\\d{9}$"
    },
    {
      name: "Qatar",
      code: "QA",
      phone_code: "+974",
      phone_regex: "^\\+974\\d{8}$"
    },
    {
      name: "Romania",
      code: "RO",
      phone_code: "+40",
      phone_regex: "^\\+40\\d{9}$"
    },
    {
      name: "Russia",
      code: "RU",
      phone_code: "+7",
      phone_regex: "^\\+7\\d{10}$"
    },
    {
      name: "Rwanda",
      code: "RW",
      phone_code: "+250",
      phone_regex: "^\\+250\\d{9}$"
    },
    {
      name: "Saint Kitts and Nevis",
      code: "KN",
      phone_code: "+1-869",
      phone_regex: "^\\+1\\-869\\d{7}$"
    },
    {
      name: "Saint Lucia",
      code: "LC",
      phone_code: "+1-758",
      phone_regex: "^\\+1\\-758\\d{7}$"
    },
    {
      name: "Saint Vincent and the Grenadines",
      code: "VC",
      phone_code: "+1-784",
      phone_regex: "^\\+1\\-784\\d{7}$"
    },
    {
      name: "Samoa",
      code: "WS",
      phone_code: "+685",
      phone_regex: "^\\+685\\d{7}$"
    },
    {
      name: "Sao Tome and Principe",
      code: "ST",
      phone_code: "+239",
      phone_regex: "^\\+239\\d{7}$"
    },
    {
      name: "Saudi Arabia",
      code: "SA",
      phone_code: "+966",
      phone_regex: "^\\+966\\d{9}$"
    },
    {
      name: "Senegal",
      code: "SN",
      phone_code: "+221",
      phone_regex: "^\\+221\\d{9}$"
    },
    {
      name: "Serbia",
      code: "RS",
      phone_code: "+381",
      phone_regex: "^\\+381\\d{8,9}$"
    },
    {
      name: "Seychelles",
      code: "SC",
      phone_code: "+248",
      phone_regex: "^\\+248\\d{7}$"
    },
    {
      name: "Sierra Leone",
      code: "SL",
      phone_code: "+232",
      phone_regex: "^\\+232\\d{8}$"
    },
    {
      name: "Singapore",
      code: "SG",
      phone_code: "+65",
      phone_regex: "^\\+65\\d{8}$"
    },
    {
      name: "Slovakia",
      code: "SK",
      phone_code: "+421",
      phone_regex: "^\\+421\\d{9}$"
    },
    {
      name: "Slovenia",
      code: "SI",
      phone_code: "+386",
      phone_regex: "^\\+386\\d{8,9}$"
    },
    {
      name: "Solomon Islands",
      code: "SB",
      phone_code: "+677",
      phone_regex: "^\\+677\\d{7}$"
    },
    {
      name: "Somalia",
      code: "SO",
      phone_code: "+252",
      phone_regex: "^\\+252\\d{8}$"
    },
    {
      name: "South Africa",
      code: "ZA",
      phone_code: "+27",
      phone_regex: "^\\+27\\d{9}$"
    },
    {
      name: "South Sudan",
      code: "SS",
      phone_code: "+211",
      phone_regex: "^\\+211\\d{9}$"
    },
    {
      name: "Spain",
      code: "ES",
      phone_code: "+34",
      phone_regex: "^\\+34\\d{9}$"
    },
    {
      name: "Sri Lanka",
      code: "LK",
      phone_code: "+94",
      phone_regex: "^\\+94\\d{9}$"
    },
    {
      name: "Sudan",
      code: "SD",
      phone_code: "+249",
      phone_regex: "^\\+249\\d{9}$"
    },
    {
      name: "Suriname",
      code: "SR",
      phone_code: "+597",
      phone_regex: "^\\+597\\d{7}$"
    },
    {
      name: "Sweden",
      code: "SE",
      phone_code: "+46",
      phone_regex: "^\\+46\\d{9}$"
    },
    {
      name: "Switzerland",
      code: "CH",
      phone_code: "+41",
      phone_regex: "^\\+41\\d{9}$"
    },
    {
      name: "Syria",
      code: "SY",
      phone_code: "+963",
      phone_regex: "^\\+963\\d{9}$"
    },
    {
      name: "Taiwan",
      code: "TW",
      phone_code: "+886",
      phone_regex: "^\\+886\\d{8,9}$"
    },
    {
      name: "Tajikistan",
      code: "TJ",
      phone_code: "+992",
      phone_regex: "^\\+992\\d{9}$"
    },
    {
      name: "Tanzania",
      code: "TZ",
      phone_code: "+255",
      phone_regex: "^\\+255\\d{9}$"
    },
    {
      name: "Thailand",
      code: "TH",
      phone_code: "+66",
      phone_regex: "^\\+66\\d{9}$"
    },
    {
      name: "Togo",
      code: "TG",
      phone_code: "+228",
      phone_regex: "^\\+228\\d{8}$"
    },
    {
      name: "Tonga",
      code: "TO",
      phone_code: "+676",
      phone_regex: "^\\+676\\d{7}$"
    },
    {
      name: "Trinidad and Tobago",
      code: "TT",
      phone_code: "+1-868",
      phone_regex: "^\\+1\\-868\\d{7}$"
    },
    {
      name: "Tunisia",
      code: "TN",
      phone_code: "+216",
      phone_regex: "^\\+216\\d{8}$"
    },
    {
      name: "Turkey",
      code: "TR",
      phone_code: "+90",
      phone_regex: "^\\+90\\d{10}$"
    },
    {
      name: "Turkmenistan",
      code: "TM",
      phone_code: "+993",
      phone_regex: "^\\+993\\d{8}$"
    },
    {
      name: "Tuvalu",
      code: "TV",
      phone_code: "+688",
      phone_regex: "^\\+688\\d{7}$"
    },
    {
      name: "Uganda",
      code: "UG",
      phone_code: "+256",
      phone_regex: "^\\+256\\d{9}$"
    },
    {
      name: "Ukraine",
      code: "UA",
      phone_code: "+380",
      phone_regex: "^\\+380\\d{9}$"
    },
    {
      name: "United Arab Emirates",
      code: "AE",
      phone_code: "+971",
      phone_regex: "^\\+971\\d{9}$"
    },
    {
      name: "United Kingdom",
      code: "GB",
      phone_code: "+44",
      phone_regex: "^\\+44\\d{9,10}$"
    },
    {
      name: "United States",
      code: "US",
      phone_code: "+1",
      phone_regex: "^\\+1\\d{10}$"
    },
    {
      name: "Uruguay",
      code: "UY",
      phone_code: "+598",
      phone_regex: "^\\+598\\d{8,9}$"
    },
    {
      name: "Uzbekistan",
      code: "UZ",
      phone_code: "+998",
      phone_regex: "^\\+998\\d{9}$"
    },
    {
      name: "Vanuatu",
      code: "VU",
      phone_code: "+678",
      phone_regex: "^\\+678\\d{7}$"
    },
    {
      name: "Vatican City",
      code: "VA",
      phone_code: "+379",
      phone_regex: "^\\+379\\d{9}$"
    },
    {
      name: "Venezuela",
      code: "VE",
      phone_code: "+58",
      phone_regex: "^\\+58\\d{10}$"
    },
    {
      name: "Vietnam",
      code: "VN",
      phone_code: "+84",
      phone_regex: "^\\+84\\d{9,10}$"
    },
    {
      name: "Yemen",
      code: "YE",
      phone_code: "+967",
      phone_regex: "^\\+967\\d{9}$"
    },
    {
      name: "Zambia",
      code: "ZM",
      phone_code: "+260",
      phone_regex: "^\\+260\\d{9}$"
    },
    {
      name: "Zimbabwe",
      code: "ZW",
      phone_code: "+263",
      phone_regex: "^\\+263\\d{9}$"
    },
    {
      name: "Abkhazia",
      code: "AB",
      phone_code: "+7 840, +7 940",
      phone_regex: "^\\+7\\s(840|940)\\d{7}$"
    },
    {
      name: "Artsakh",
      code: "NK",
      phone_code: "+374 97",
      phone_regex: "^\\+374\\s97\\d{6}$"
    },
    {
      name: "Cook Islands",
      code: "CK",
      phone_code: "+682",
      phone_regex: "^\\+682\\d{5}$"
    },
    {
      name: "French Polynesia",
      code: "PF",
      phone_code: "+689",
      phone_regex: "^\\+689\\d{6}$"
    },
    {
      name: "Kosovo",
      code: "XK",
      phone_code: "+383",
      phone_regex: "^\\+383\\d{8}$"
    },
    {
      name: "New Caledonia",
      code: "NC",
      phone_code: "+687",
      phone_regex: "^\\+687\\d{6}$"
    },
    {
      name: "Niue",
      code: "NU",
      phone_code: "+683",
      phone_regex: "^\\+683\\d{4}$"
    },
    {
      name: "Northern Cyprus",
      code: "NCY",
      phone_code: "+90 392",
      phone_regex: "^\\+90\\s392\\d{7}$"
    },
    {
      name: "Puerto Rico",
      code: "PR",
      phone_code: "+1-787, +1-939",
      phone_regex: "^\\+1\\-(787|939)\\d{7}$"
    },
    {
      name: "South Ossetia",
      code: "OS",
      phone_code: "+7 997",
      phone_regex: "^\\+7\\s997\\d{6}$"
    },
    {
      name: "Tokelau",
      code: "TK",
      phone_code: "+690",
      phone_regex: "^\\+690\\d{4}$"
    },
    {
      name: "Wallis and Futuna",
      code: "WF",
      phone_code: "+681",
      phone_regex: "^\\+681\\d{6}$"
    },
    {
      name: "American Samoa",
      code: "AS",
      phone_code: "+1-684",
      phone_regex: "^\\+1\\-684\\d{7}$"
    },
    {
      name: "Anguilla",
      code: "AI",
      phone_code: "+1-264",
      phone_regex: "^\\+1\\-264\\d{7}$"
    },
    {
      name: "Antarctica",
      code: "AQ",
      phone_code: "+672",
      phone_regex: "^\\+672\\d{4,6}$"
    },
    {
      name: "Aruba",
      code: "AW",
      phone_code: "+297",
      phone_regex: "^\\+297\\d{7}$"
    },
    {
      name: "Bermuda",
      code: "BM",
      phone_code: "+1-441",
      phone_regex: "^\\+1\\-441\\d{7}$"
    },
    {
      name: "British Indian Ocean Territory",
      code: "IO",
      phone_code: "+246",
      phone_regex: "^\\+246\\d{7}$"
    },
    {
      name: "British Virgin Islands",
      code: "VG",
      phone_code: "+1-284",
      phone_regex: "^\\+1\\-284\\d{7}$"
    },
    {
      name: "Cayman Islands",
      code: "KY",
      phone_code: "+1-345",
      phone_regex: "^\\+1\\-345\\d{7}$"
    },
    {
      name: "Christmas Island",
      code: "CX",
      phone_code: "+61",
      phone_regex: "^\\+61\\d{9}$"
    },
    {
      name: "Cocos (Keeling) Islands",
      code: "CC",
      phone_code: "+61",
      phone_regex: "^\\+61\\d{9}$"
    },
    {
      name: "Curaçao",
      code: "CW",
      phone_code: "+599",
      phone_regex: "^\\+599\\d{7}$"
    },
    {
      name: "Falkland Islands",
      code: "FK",
      phone_code: "+500",
      phone_regex: "^\\+500\\d{5}$"
    },
    {
      name: "Faroe Islands",
      code: "FO",
      phone_code: "+298",
      phone_regex: "^\\+298\\d{6}$"
    },
    {
      name: "Gibraltar",
      code: "GI",
      phone_code: "+350",
      phone_regex: "^\\+350\\d{8}$"
    },
    {
      name: "Greenland",
      code: "GL",
      phone_code: "+299",
      phone_regex: "^\\+299\\d{6}$"
    },
    {
      name: "Guam",
      code: "GU",
      phone_code: "+1-671",
      phone_regex: "^\\+1\\-671\\d{7}$"
    },
    {
      name: "Guernsey",
      code: "GG",
      phone_code: "+44",
      phone_regex: "^\\+44\\d{10}$"
    },
    {
      name: "Hong Kong",
      code: "HK",
      phone_code: "+852",
      phone_regex: "^\\+852\\d{8}$"
    },
    {
      name: "Isle of Man",
      code: "IM",
      phone_code: "+44",
      phone_regex: "^\\+44\\d{10}$"
    },
    {
      name: "Jersey",
      code: "JE",
      phone_code: "+44",
      phone_regex: "^\\+44\\d{10}$"
    },
    {
      name: "Macau",
      code: "MO",
      phone_code: "+853",
      phone_regex: "^\\+853\\d{8}$"
    },
    {
      name: "Mayotte",
      code: "YT",
      phone_code: "+262",
      phone_regex: "^\\+262\\d{9}$"
    },
    {
      name: "Montserrat",
      code: "MS",
      phone_code: "+1-664",
      phone_regex: "^\\+1\\-664\\d{7}$"
    },
    {
      name: "Northern Mariana Islands",
      code: "MP",
      phone_code: "+1-670",
      phone_regex: "^\\+1\\-670\\d{7}$"
    },
    {
      name: "Palestine",
      code: "PS",
      phone_code: "+970",
      phone_regex: "^\\+970\\d{9}$"
    },
    {
      name: "Pitcairn Islands",
      code: "PN",
      phone_code: "+64",
      phone_regex: "^\\+64\\d{8}$"
    },
    {
      name: "Réunion",
      code: "RE",
      phone_code: "+262",
      phone_regex: "^\\+262\\d{9}$"
    },
    {
      name: "Saint Helena, Ascension and Tristan da Cunha",
      code: "SH",
      phone_code: "+290, +247",
      phone_regex: "^\\+(290|247)\\d{4,5}$"
    },
    {
      name: "Saint Pierre and Miquelon",
      code: "PM",
      phone_code: "+508",
      phone_regex: "^\\+508\\d{6}$"
    },
    {
      name: "San Marino",
      code: "SM",
      phone_code: "+378",
      phone_regex: "^\\+378\\d{6}$"
    },
    {
      name: "Sint Maarten",
      code: "SX",
      phone_code: "+1-721",
      phone_regex: "^\\+1\\-721\\d{7}$"
    },
    {
      name: "Svalbard and Jan Mayen",
      code: "SJ",
      phone_code: "+47",
      phone_regex: "^\\+47\\d{8}$"
    },
    {
      name: "Timor-Leste",
      code: "TL",
      phone_code: "+670",
      phone_regex: "^\\+670\\d{7,8}$"
    },
    {
      name: "Turks and Caicos Islands",
      code: "TC",
      phone_code: "+1-649",
      phone_regex: "^\\+1\\-649\\d{7}$"
    },
    {
      name: "United States Minor Outlying Islands",
      code: "UM",
      phone_code: "+1",
      phone_regex: "^\\+1\\d{10}$"
    },
    {
      name: "Virgin Islands, U.S.",
      code: "VI",
      phone_code: "+1-340",
      phone_regex: "^\\+1\\-340\\d{7}$"
    }
  ]
};

export const ConstantsContext = React.createContext(AppConstants);
export const ConstantsProvider = ConstantsContext.Provider;
